var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-90 0 48)",
    fill: "#F2F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7029 31.1404C27.6056 31.492 27.2971 31.7561 26.9216 31.7839L26.8552 31.7859H14.53C14.0659 31.7859 13.6848 31.4269 13.6511 30.9714L13.6492 30.905V18.5798C13.6492 18.1756 13.9214 17.8336 14.2927 17.7302L27.7029 31.1404ZM32.4324 20.2595C33.0778 19.9075 33.899 20.3302 33.8992 21.0144V28.4695C33.8992 29.0362 33.3363 29.4221 32.7761 29.3386L29.0564 25.6189V22.1013L32.4324 20.2595ZM26.8552 17.699C27.3193 17.699 27.7004 18.058 27.7341 18.5134L27.7361 18.5798V24.2986L21.1365 17.699H26.8552Z",
    fill: "#F53F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 15.3007L32.6998 32.7007",
    stroke: "#F53F3F",
    strokeWidth: 1.215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraClose);
export default __webpack_public_path__ + "static/media/CameraClose.3477d1ebf2eac1aa2e39d0af3826434b.svg";
export { ForwardRef as ReactComponent };